'use client';

import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'next-themes';
import { ToolbarButton } from './components/toolbar-button';
export function ThemeModeToggle() {
  const $ = _c(8);
  const {
    setTheme,
    theme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== theme) {
    t0 = e => {
      setTheme(theme === "light" ? "dark" : "light");
      e.currentTarget.blur();
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SunIcon className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />;
    t2 = <MoonIcon className="dark:text-foreground absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />;
    t3 = <span className="sr-only">Toggle theme</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t0) {
    t4 = <ToolbarButton tabIndex={0} title="Toggle theme" onClick={t0}>{t1}{t2}{t3}</ToolbarButton>;
    $[6] = t0;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
interface IconProps {
  className?: string;
}
function MoonIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function SunIcon(props) {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="12" cy="12" r="4" />;
    t1 = <path d="M12 2v2" />;
    t2 = <path d="M12 20v2" />;
    t3 = <path d="m4.93 4.93 1.41 1.41" />;
    t4 = <path d="m17.66 17.66 1.41 1.41" />;
    t5 = <path d="M2 12h2" />;
    t6 = <path d="M20 12h2" />;
    t7 = <path d="m6.34 17.66-1.41 1.41" />;
    t8 = <path d="m19.07 4.93-1.41 1.41" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}